<!--
 * @Descripttion:
 * @Author: lcf
 * @Date: 2022-03-15 09:39:58
 * @LastEditors: 姚林刚
 * @LastEditTime: 2023-05-04 11:14:56
-->

<template>
  <div class="bottom">
    <div class="bottom_btns">
      <div v-for="(item, index) in navigations" :key="index">
        <div
          v-if="item.isShow"
          v-hasPermissions:flex="[item.permissionName]"
          @click="switchMenu(item.clickName)"
          :class="[
            $route.path == item.path
              ? 'active'
              : $route.path.includes('/governmentAffairs') &&
                item.path.includes('/governmentAffairs')
              ? 'active'
              : '',
            'btn btn1',
          ]"
        >
          {{ item.name }}
        </div>
      </div>
      <div class="addon-navigations" v-if="addonNavigations.length">
        <template v-for="item in addonNavigations">
          <div
            @click="goAddonNavigation(item)"
            class="item"
            :key="item.label"
            v-if="item.isShow"
          >
            {{ item.label }}
          </div>
        </template>
      </div>
    </div>
    <div class="copyright">技术支持：国家农机装备创新中心</div>
  </div>
</template>
<script>
import store from "@/store";
import auth from "@/plugins/auth";

// 部分地区会在底部导航右侧增加额外的按钮，比如「农机调度」
const ADDON_NAVIGATIONS = {
  // 濮阳县
  410928000: [],
  // 舞阳县
  411121000: [],
  // 滑县
  410526000: [],
  // 兰考县
  410225000: [
    {
      label: "农机调度",
      href: "http://ham.chiaic.com/vehicleManagement/vehicleTrack/index",
    },
  ],
};

export default {
  inject: ["reload"],
  data() {
    return {
      currentMenu: 1,
      timer: null,
      week: "",
      cloak: {
        time: "",
        date: "",
      },
      governmentArr: [],
      permissionBtnArr: [], //所有权限按钮
      // 底部按钮
      btnArr: [
        {
          name: "农机分布",
          permissionName: "screen:vehicle",
          clickName: 1,
          routeName: "Home",
          path: "/home",
          routePermi: "home",
          isShow: true,
        },
        {
          name: "作业进度",
          permissionName: "screen:job",
          clickName: 2,
          routeName: "WorkInfo",
          path: "/work_info",
          routePermi: "work_info",
          isShow: true,
        },
        {
          name: "政务服务",
          permissionName: "screen:gov",
          clickName: 5,
          routeName: "purchaseAllowance",
          routePermi: "affairs",
          path: "/governmentAffairs/purchaseAllowance",
          isShow: true,
        },
        {
          name: "农机监理",
          permissionName: "screen:gov:vehiclesupervisor",
          routeName: "Vehiclesupervisor",
          path: "/governmentAffairs/vehiclesupervisor",
          isShow: false,
        },
        {
          name: "报废补贴",
          permissionName: "screen:gov:ScrapSubsidy",
          routeName: "ScrapSubsidy",
          path: "/governmentAffairs/scrapSubsidy",
          isShow: false,
        },
        {
          name: "合作社",
          permissionName: "screen:croop",
          clickName: 3,
          routeName: "newCooperative",
          routePermi: "new_cooperative",
          path: "/new_cooperative",
          isShow: true,
        },
        {
          name: "社会化服务",
          permissionName: "screen:socialization",
          clickName: 4,
          routeName: "Socialization",
          routePermi: "socialization",
          path: "/socialization",
          isShow: true,
        },
        {
          name: "智慧AI调度",
          permissionName: "screen:aiDispatch",
          clickName: "AiDispatch",
          routeName: "AiDispatch",
          path: "/aiDispatch",
          routePermi: "AiDispatch",
          isShow: true,
        },
      ],
      permissionGatewayRunning: false,
    };
  },
  created() {
    console.log(this.$store.getters.permissions);
  },
  mounted() {},
  beforeDestroy() {
    clearInterval(this.timer);
  },
  watch: {
    "$store.state.activeRegionObj": {
      deep: true,
      immediate: true,
      handler(val) {
        const intersectionRouter = this.checkAreaPermissionsSetting();
        const routePath = this.$route.path;
        // 当前登录权限未匹配到选择区域权限，自动跳转到农机分布
        if (
          routePath != "/" &&
          val &&
          val.areaCode &&
          !intersectionRouter.includes(routePath.slice(1))
        ) {
          this.$router.push({
            path: "/",
          });
        }
      },
      deep: true,
      immediate: true,
    },
    "$store.state.permissions": {
      deep: true,
      immediate: true,
      handler(val) {
        this.$nextTick(() => {
          this.permissionBtnArr = [];
          this.btnArr.forEach((item) => {
            if (this.checkHasPermissions([item.permissionName])) {
              this.permissionBtnArr.push(item);
            }
          });
        });
      },
    },
    "$store.state.dvPermissionsReady": {
      handler(v) {
        console.log("%cdvPermissionsReady", "color:#CC0", v);
        if (v) {
          let self = this;
          self.goPermissionGateway("$store.dvPermissionsReady");
        }
      },
    },
    $route: {
      deep: true,
      handler(newVal) {
        console.log("watch.$route", { ...newVal });
        let self = this;
        self.goPermissionGateway("$route.change");
      },
    },
  },
  computed: {
    addonNavigations() {
      let self = this;
      const area = self.$store.state.activeRegionObj || {};
      const list = ADDON_NAVIGATIONS[area.areaCode] || [];
      return list;
    },
    navigations() {
      /*
      const intersectionRouter = this.checkAreaPermissionsSetting();
      console.log('intersectionRouter :>> ', intersectionRouter);
      return this.btnArr.filter(v=> {
        // 返回对应按钮，超级管理员除外
        return intersectionRouter.includes(v.routePermi) || this.$store.getters.roles.includes('admin')
      })
      */
      let self = this;
      const permissions = self.$store.getters.permissions || [];
      const managerEnabled = true;
      let list =
        permissions.includes("*:*:*") && managerEnabled
          ? self.btnArr
          : self.btnArr.filter((btn) =>
              permissions.includes(btn.permissionName)
            );
      return list;
    },
  },
  methods: {
    // 判断政务大屏权限只包含政务、同时不包含农机鉴定、购置补贴、报废补贴、农机监理
    checkGovernmentBtnArray(arr) {
      this.governmentArr = arr.filter((item) => {
        return item.permissionName.startsWith("screen:gov");
      });
      if (this.governmentArr.length == 1) {
        return true;
      } else {
        return false;
      }
    },
    checkAreaPermissionsSetting() {
      const userDeptAreaCode =
        this.$store.getters && this.$store.getters.getUserDeptAreaCode;
      const selectAreaCode =
        this.$store.state.activeRegionObj &&
        this.$store.state.activeRegionObj.areaCode;
      const areaPermissionsSetting =
        this.$store.getters && this.$store.getters.getAreaPermissionsSetting;
      // 当前登录账号路由权限,默认还有农机分布、作业进度，前两个大屏不需要配置
      const userRouterSeting = areaPermissionsSetting.find((v) => {
        return v.dictLabel == userDeptAreaCode;
      })?.dictValue;
      // 当前选择区域路由权限,默认还有农机分布、作业进度，前两个大屏不需要配置
      const selectAreaRouterSeting = areaPermissionsSetting.find((v) => {
        return v.dictLabel == selectAreaCode;
      })?.dictValue;
      console.log(
        "userRouterSeting 当前登录账号路由权限:>> ",
        userRouterSeting
      );
      console.log(
        "selectAreaRouterSeting 当前选择区域路由权限:>> ",
        selectAreaRouterSeting
      );
      const userArr = [
        "home",
        "work_info",
        ...(userRouterSeting ? userRouterSeting.split(",") : []),
      ];
      const areaArr = [
        "home",
        "work_info",
        ...(selectAreaRouterSeting ? selectAreaRouterSeting.split(",") : []),
      ];
      // // 返回当前登录和所选择区域的交集路由
      // return userArr.filter(item => areaArr.includes(item));
      return areaArr;
    },
    // 无权时跳转到第一个有权限的菜单
    goPermissionGateway(reason) {
      console.log("%cgoPermissionGateway", "color:#C0C", reason);
      let self = this;
      if (self.permissionGatewayRunning) {
        console.log("permissionGatewayRunning", self.permissionGatewayRunning);
        return;
      }
      self.permissionGatewayRunning = true;
      const check = () => {
        if (self.$store.state.dvPermissionsReady) {
          console.log(
            "%c路由变动开始检测权限但权限已到位，开始检测当前页面的权限",
            "color:#C0C",
            { reason }
          );
          self.permissionGatewayRunning = false;
          const validRouters = self.navigations.filter((v) => !v.disabled);
          const validRouterPaths = validRouters.map((v) => v.path);
          const currentPage = self.$route;
          if (
            !validRouterPaths.includes(currentPage.path) &&
            currentPage.path != "/"
          ) {
            console.log(
              "%c无权访问大屏的当前页面:",
              "color:#C0C",
              currentPage.path,
              reason,
              {
                currentPage,
                validRouters,
                validRouterPaths,
                navigations: self.navigations,
                permissions: self.$store.getters.permissions,
              }
            );
            if (validRouterPaths.length) {
              let newRouter = validRouters[0];
              let newRouterPath = newRouter.path;
              // let newPagePath = newRouter.path;
              // self.$message({
              //   message: `无权访问 <strong>${currentPage.path}</strong> 正在转到 <strong>${newPagePath || ''}</strong>`,
              //   duration: 1500,
              //   type: 'warning',
              //   dangerouslyUseHTMLString: true,
              //   showClose: true,
              // });
              console.log(
                "%c无权访问的路由:",
                "color:#C00",
                currentPage.path,
                reason,
                currentPage,
                `正在转到:${newRouterPath}`,
                { validRouterPaths }
              );
              self.$router.replace({
                path: newRouterPath,
                query: currentPage.query,
              });
            } else {
              console.log(
                "%c没有使用大屏的任何权限",
                "color:#C0C",
                currentPage.path,
                reason,
                { currentPage, validRouterPaths }
              );
              self.$alert("您没有使用大屏的权限", "无权访问", {
                confirmButtonText: "刷新重试",
                confirmButtonClass: "el-button el-button--success is-round",
                center: true,
                showClose: false,
                callback: (action) => {
                  window.location.reload();
                },
              });
            }
          } else {
            console.log(
              "%c有权访问大屏的当前页面:",
              "color:#C0C",
              currentPage.path,
              reason,
              { currentPage, validRouters, validRouterPaths }
            );
          }
        } else {
          console.log(
            "%c路由变动开始检测权限但权限未到位，等待中…",
            "color:#C0C",
            { reason }
          );
          setTimeout(() => {
            check();
          }, 500);
        }
      };
      check();
    },
    checkHasPermissions(permissions) {
      const isSuperUser = (
        (store.getters && store.getters.roles) ||
        []
      ).includes("admin");
      return isSuperUser || auth.hasPermiOr(permissions);
    },
    out() {
      window.location.href = "about:blank";
      window.close();
    },
    prev() {
      this.$router.go(-1);
    },
    switchMenu(index) {
      this.currentMenu = index;
      if (index == 1) {
        if (this.$route.name == "Home") {
          this.reload();
        } else {
          this.$router.push({
            path: "/",
          });
        }
      } else if (index == 2) {
        if (this.$route.name == "WorkInfo") {
          this.reload();
        } else {
          this.$router.push({
            path: "/work_info",
          });
        }
      } else if (index == 3) {
        if (this.$route.name == "newCooperative") {
          this.reload();
        } else {
          this.$router.push({
            path: "/new_cooperative",
          });
        }
      } else if (index == 4) {
        if (this.$route.name == "socialization") {
          this.reload();
        } else {
          this.$router.push({
            path: "/socialization",
          });
        }
      } else if (index == "AiDispatch") {
        if (this.$route.name == "AiDispatch") {
          this.reload();
        } else {
          this.$router.push({
            path: "/aiDispatch",
          });
        }
      } else if (index == 5) {
        if (this.$route.name == "purchaseAllowance") {
          this.reload();
        } else {
          let needObj = {
            path: `/governmentAffairs/purchaseAllowance`,
          };
          // ['农机鉴定', '购置补贴', '农机监理', '报废补贴'],
          if (this.governmentArr && this.governmentArr.length > 1) {
            for (let i = 0; i < this.governmentArr.length; i++) {
              if (
                this.governmentArr[i].name == "农机鉴定" ||
                this.governmentArr[i].name == "购置补贴" ||
                this.governmentArr[i].name == "农机监理" ||
                this.governmentArr[i].name == "报废补贴"
              ) {
                needObj = this.governmentArr[i];
                break;
              }
            }
          }
          this.$router.push({
            path: needObj.path,
          });
        }
      }
    },
    goAddonNavigation(item) {
      let token = sessionStorage.getItem("token");
      window.open(item.href + "?token=" + token);
    },
  },
};
</script>
<style lang="scss">
@function vw($px) {
  @return ($px / 1920) * 100vw;
}
@function vh($px) {
  @return ($px / 1080) * 100vh;
}
.bottom {
  position: fixed;
  bottom: vh(16);
  display: flex;
  align-items: flex-end;
  z-index: 2;
  width: 100%;
  .copyright {
    font-size: vw(14);
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #75ba7d;
    margin: 0 auto;
    margin-bottom: vh(-12);
  }
  .bottom_btns {
    flex: 1;
    position: relative;
    display: flex;
    position: absolute;
    /* left: 50%; */
    width: 100%;
    justify-content: center;
    bottom: vh(13);
    .btn_old {
      display: flex;
      justify-content: center;
      align-items: center;
      color: #fff;
      font-size: vw(24);
      background-size: 100% 100% !important;
      position: relative;
      background-repeat: no-repeat !important;
      cursor: pointer;
      background: url("../../../assets/images/common/btn_bottom.png");
      width: vw(170);
      height: vh(71);
      padding-bottom: vh(20);
    }
    .btn {
      display: flex;
      justify-content: center;
      align-items: center;
      color: #fff;
      font-size: vw(22);
      background-size: 100% 100% !important;
      position: relative;
      background-repeat: no-repeat !important;
      cursor: pointer;
      background: url("../../../assets/images/common/btn_bottom.png");
      width: vw(127);
      height: vh(66);
      padding-bottom: vh(14);
    }
    .btn1_old {
      margin-right: vw(8);
    }
    .btn1 {
      margin-right: vw(8);
    }
    .active {
      background: url("../../../assets/images/common/btn_bottom_c.png");
    }
  }
  .addon-navigations {
    width: vw(170);
    height: vh(71);
    position: absolute;
    right: vw(424);
    display: flex;
    justify-content: center;
    align-items: flex-end;
    .item {
      font-size: vw(18);
      background: url("../../../assets/images/common/btn_bottom_njdd.png");
      display: flex;
      justify-content: center;
      align-items: center;
      color: #fff;
      background-size: 100% 100% !important;
      position: relative;
      background-repeat: no-repeat !important;
      cursor: pointer;
      width: vw(140);
      height: vh(58);
      padding-bottom: vh(20);
    }
  }
}
</style>
